var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',{staticClass:"arc"},_vm._l((_vm.arcData),function(item,index){return _c('path',{key:index,ref:`arc`,refInFor:true,class:_vm.name,style:(_vm.styleAttributes[index]),attrs:{"d":_vm.pathData(item)},on:{"mouseover":function($event){return _vm.handleMouseOver($event, item, index)},"mouseout":_vm.handleMouseOut}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }